import api, { headers } from "./api";

export const getBlogs = async () => {
    return await api.get(
        `/blogs?page=1`,
        {
            headers,
        }
    );
};

export const getFeaturedBlogs = async () => {
    return await api.get(
        `/blogs/?page=1&featured=true`,
        {
            headers,
        }
    );
};

export const getBlogById = async (blogId) => {
    return await api.get(
        `/blogs/${blogId}`,
        {
            headers,
        }
    );
};

export const createBlog = async (blogData) => {
    return await api.post(
        `/blogs`,
        blogData,
        {
            headers,
        }
    );
};

export const updateBlog = async (blogId, blogData) => {
    return await api.put(
        `/blogs/${blogId}`,
        blogData,
        {
            headers,
        }
    );
};

export const deleteBlog = async (blogId) => {
    return await api.delete(
        `/blogs/${blogId}`,
        {
            headers,
        }
    );
};

/* export const uploadBlogMedia = async (studentId, body) => {
    return await api.post(`${STUDENT_URL}/${studentId}/media`, body);
}; */
